<s1-input-select [control]="control" [itemsList]="status" [label]="label" [grouped]="grouped" [readonly]="readonly"></s1-input-select>